import { SearchDropdown } from "@/components/ui/search-dropdown";
import type { Table } from "@/queries/data-center/data-center.api";
import { cn } from "@/utils/theme";
import { Badge, Icon } from "@elaniintc/goes-design-system";
import { useDataCenterNode } from "../context";

export const DCTableSelector = () => {
  const {
    tables,
    selectedTable,
    setSelectedTable,
    isLoadingMoreTables,
    isReadyToShow,
    hasMoreTables,
    loadMoreTables,
    reset,
    setTableSearchQuery,
  } = useDataCenterNode();
  if (!tables) return null;

  return (
    <SearchDropdown<Table>
      group="left"
      widthClassName="flex-auto min-w-0"
      contentWidthClassName="w-[var(--radix-dropdown-menu-trigger-width)]"
      searchPlaceholder="Buscar..."
      placeholder="Seleccionar una tabla"
      data={tables}
      fetchNextPage={() => {
        if (hasMoreTables && !isLoadingMoreTables) {
          loadMoreTables();
        }
      }}
      onSearch={(searchString) => setTableSearchQuery(searchString)}
      hasNextPage={hasMoreTables}
      isLoading={!isReadyToShow}
      isEmpty={tables.length === 0}
      isFetching={isLoadingMoreTables}
      selectedItem={selectedTable}
      renderItem={(item, index, closeMenu, isSelectedShowing) => {
        return (
          <div
            className={cn(
              "cursor-pointer w-full rounded-lg flex gap-3 items-center",
              index >= 0
                ? "flex-auto px-3 py-2 text-body hover:text-body-loud hover:bg-neutral-object-accent-quiet outline-none"
                : "flex-1 min-w-0",
            )}
            onClick={() => {
              if (isSelectedShowing) return;
              setSelectedTable(item);
              reset();
              closeMenu();
            }}
          >
            <Icon type="far" name="table" className="text-body flex-shrink-0" />
            <div className="flex gap-2 items-center flex-auto min-w-0">
              <span className="text-body font-body truncate">{item.name}</span>
            </div>
            <Badge
              shape="pill"
              size="sm"
              variant={item && item.source === "sdt" ? "action" : "neutral"}
              className="flex-shrink-0"
            >
              {item.source === "sdt" ? "Local" : item.source}
            </Badge>
          </div>
        );
      }}
    />
  );
};
